import { render, staticRenderFns } from "./DetailsPrescription.vue?vue&type=template&id=06864b7e&"
import script from "./DetailsPrescription.vue?vue&type=script&lang=js&"
export * from "./DetailsPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports